export const inputParam = ['customerID'];
export const defaultParam = {
  startDate1: `"2019-08-01"`,
  startDate2: `"2019-08-01"`,
  startDate3: `"2019-08-01"`,
  startDate4: `"2019-08-01"`,
  startDate5: `"2019-07-01"`,
  startDate6: `"2019-08-01"`,
  startDate7: `"2019-07-01"`,
  startDate8: `"2019-08-01"`,
  startDate9: `"2019-08-01"`,
  startDate19: `"2019-08-01"`,
  endDate1: `"2019-09-30"`,
  DaysDuration1: 35,
  DaysDuration2: 35,
  DaysDuration3: 35,
  DaysDuration4: 35,
  DaysDuration5: 35,
  DaysDuration6: 35,
  DaysDuration7: 35,
  DaysDuration8: 35,
  DaysDuration9: 35,
  DaysDuration10: 35,
  PercentageFactor1: 0.6,
  PercentageFactor2: 0.6,
  PercentageFactor3: 0.6,
  PercentageFactor4: 0.6,
  scoreWeight1: 10,
  scoreWeight2: 10,
  scoreWeight3: 10,
  scoreWeight4: 10,
  scoreWeight5: 10,
  scoreWeight6: 10,
  scoreWeight7: 10,
  scoreWeight8: 10,
  scoreWeight9: 10,
  scoreWeight10: 10,
  scoreWeight11: 10,
  AllowedNumberOfDeposits: 4,
  MinCountryFraudScore1: 0.6,
  MinCountryFraudScore2: 0.6,
  MinCountryFraudScore3: 0.6,
  TransactionLimit: 150000,
  DaysBetweenTransacation: 30,
  MinTransctionAmount: 500,
  MinTotalTransactionCount: 2,
  MinAmountRecieved: 6500,
  MinTotalDeposit: 8500,
  MinTotalCashWithdrawan: 10000,
  MinDeposit: 10000,
  DaysRange1: 10,
  DaysRange2: 10,
  DaysRange3: 10,
  PercentageWithdrawal1: 0.75,
  PercentageWithDrawal2: 10,
  PercentageWithDrawal3: 0.5,
  AverageWeeklyDeposits: 5,
  AverageNumOfDeposits: 5,
  maxOwners: 3,
  minimumDevices: 10,
  minimumCities: 1,
  similarityCutoff: 0.5,
  durationInMonths: 8,
  salaryIncreaseRatio: 1.5,
  dateOpen: `"2020-01-10"`,
  maxIncomeRatio: 1.3,
  confidenceFactor: 0.5
};

export const ParamLabel = {
  startDate1: 'Start Date',
  startDate2: 'Start Date',
  startDate3: 'Start Date',
  startDate4: 'Start Date',
  startDate5: 'Start Date',
  startDate6: 'Start Date',
  startDate7: 'Start Date',
  startDate8: 'Start Date',
  startDate9: 'Start Date',
  startDate10: 'Start Date',
  endDate1: 'End Date',
  DaysDuration1: 'Days Duration',
  DaysDuration2: 'Days Duration',
  DaysDuration3: 'Days Duration',
  DaysDuration4: 'Days Duration',
  DaysDuration5: 'Days Duration',
  DaysDuration6: 'Days Duration',
  DaysDuration7: 'Days Duration',
  DaysDuration8: 'Days Duration',
  DaysDuration9: 'Days Duration',
  DaysDuration10: 'Days Duration',
  PercentageFactor1: 'Percentage Factor',
  PercentageFactor2: 'Percentage Factor',
  PercentageFactor3: 'Percentage Factor',
  PercentageFactor4: 'Percentage Factor',
  scoreWeight1: 'Score Weight',
  scoreWeight2: 'Score Weight',
  scoreWeight3: 'Score Weight',
  scoreWeight4: 'Score Weight',
  scoreWeight5: 'Score Weight',
  scoreWeight6: 'Score Weight',
  scoreWeight7: 'Score Weight',
  scoreWeight8: 'Score Weight',
  scoreWeight9: 'Score Weight',
  scoreWeight10: 'Score Weight',
  scoreWeight11: 'Score Weight',
  AllowedNumberOfDeposits: 'Allowed Number Of Deposits',
  MinCountryFraudScore1: 'Minimum Country Fraud Score',
  MinCountryFraudScore2: 'Minimum Country Fraud Score',
  MinCountryFraudScore3: 'Minimum Country Fraud Score',
  TransactionLimit: 'Transaction Limit',
  DaysBetweenTransacation: 'Days Between Transacation',
  MinTransctionAmount: 'Minimum Transction Amount',
  MinTotalTransactionCount: 'Minimum Total Transaction Count',
  MinAmountRecieved: 'Minimum Amount Recieved',
  MinTotalDeposit: 'Minimum Total Deposit',
  MinTotalCashWithdrawan: 'Minimum Total Cash Withdrawan',
  MinDeposit: 'Min Deposit',
  DaysRange1: 'Days Range',
  DaysRange2: 'Days Range',
  DaysRange3: 'Days Range',
  PercentageWithdrawal1: 'Percentage Withdrawal',
  PercentageWithDrawal2: 'Percentage Withdrawal',
  PercentageWithDrawal3: 'Percentage Withdrawal',
  AverageWeeklyDeposits: 'Average Weekly Deposits',
  AverageNumOfDeposits: 'Average Number Of Deposits',
  maxOwners: 'Maximum Owners',
  minimumDevices: 'Minimum Devices',
  minimumCities: 'Minimum Cities',
  similarityCutoff: 'Similarity Cutoff',
  durationInMonths: 'Duration In Months',
  salaryIncreaseRatio: 'Salary Increase Ratio',
  dateOpen: 'Line of Credit Open Date',
  maxIncomeRatio: 'Maximum Income Ratio',
  confidenceFactor: 'Confidence Factor'
};
export const AmlPages = [
  'AML Corporate',
  'AML Consumer',
  'Entity Resolution',
  'Shared PII'
];
export const AmlGlobalMap = new Map([
  ['AML Corporate', 'AML-Corporate'],
  ['AML Consumer', 'AML-Consumer'],
  ['Entity Resolution', 'Entity-Resolution-Global'],
  ['Shared PII', 'shared-pii']
]);
export const AmlIndividualMap = new Map([
  ['AML Corporate', 'AML-Corporate-Individual'],
  ['AML Consumer', 'AML-Consumer-Individual'],
  ['Entity Resolution', 'Entity-Resolution'],
  ['Shared PII', 'shared-pii']
]);

export const AmlAssociationMap = new Map([
  ['AML Corporate', 'AML-Corporate-Association'],
  ['AML Consumer', 'AML-Consumer-Association'],
  ['Entity Resolution', 'Entity-Resolution'],
  ['Shared PII', 'shared-pii']
]);

export const Dashboards = ['AML-Dashboard', 'Fraud-Dashboard', 'Circular-Payment'];
export const FraudPages = ['Credit Fraud'];
export const FraudGlobalMap = new Map([['Credit Fraud', 'Credit-Fraud']]);
export const FraudIndividualMap = new Map([
  ['Credit Fraud', 'Credit-Fraud-Individual']
]);

export const AmlAccountAlerts = [
  {
    id: 55716,
    name: 'Trioptics, Inc.',
    color: 'Red'
  },
  {
    id: 57907,
    name: 'Becker, Fadel and Stark',
    color: 'Orange'
  },
  {
    id: 52121,
    name: 'Hunters Run Property Owners Association, Inc',
    color: 'Red'
  },
  {
    id: 56815,
    name: 'Purdy and Sons',
    color: 'Orange'
  },
  {
    id: 59981,
    name: 'Bowie Refined Coal, Llc',
    color: 'LimeGreen'
  },
  {
    id: 58138,
    name: 'Ford Credit India Private Limited',
    color: 'Orange'
  },
  {
    id: 56430,
    name: 'Duke J Won And Hae Kyu Won',
    color: 'Orange'
  },
  {
    id: 50655,
    name: 'Air Force Villages, Inc.',
    color: 'LimeGreen'
  }
];

export const FraudAccountAlerts = [
  {
    id: 38899,
    name: 'Breckon, Hyacinthie',
    color: 'Red'
  },
  {
    id: 40793,
    name: 'Danielsohn, Gilburt',
    color: 'Red'
  },
  {
    id: 38904,
    name: 'Weedenburg, Freddie',
    color: 'Red'
  },
  {
    id: 28843,
    name: 'Halladay, Timothea',
    color: 'LimeGreen'
  },
  {
    id: 13069,
    name: 'Dobbinson, Ruggiero',
    color: 'LimeGreen'
  },
  {
    id: 59327,
    name: 'Mitchell Inc',
    color: 'Orange'
  },
  {
    id: 28839,
    name: 'Gumn, Kati',
    color: 'Red'
  },
  {
    id: 41513,
    name: 'McQuillin, Jourdan',
    color: 'Orange'
  }
];

export const CorporateAccountNames = [
  'gaudio y fuentes spa',
  'comercial zona portátil spa',
  'servicios generales jemagcar ltda',
  'global kerry spa',
  'bo yeon lee',
  'inversiones imperio spa',
  'importación y venta de tecnología spa',
  'click spa',
  'afr e.i.r.l',
  'loi chile spa'
];
export const ConsumerAccountNames = [
  'jiacheng, liu',
  'andrea carolina, ramirez banezca',
  'pablo andrés, cerón zúñiga',
  'enrique, cabrera',
  'claudio andrés, barra henriquez',
  'arturo, briceño',
  'mengdan, tang',
  'diego, casanova',
  'cristian, schweizer',
  'hernan patricio, arancibia diaz'
];
